export default "__VITE_ASSET__ZCqVP6Jc__"